import React from "react";
import styled from "@emotion/styled";
import DisplayType from "utils/displayType";
import { Link } from "react-router-dom";
import { InsightMenu } from "admin/type/type";

interface Props {
  selectedTab: InsightMenu;
  style?: React.CSSProperties;
}
const InsightTabs: React.FC<Props> = (props) => {
  const mode = DisplayType();
  return (
    <Container style={{ ...props.style }}>
      <TabContainer className="limit__body">
        <Link to="/insight" style={{ textDecoration: "none" }}>
          <TabItemContainer
            className={
              mode === "Mobile" ? "font-button1-en" : "font-button1-en"
            }
            isSelected={props.selectedTab === InsightMenu.ALL}
          >
            All
          </TabItemContainer>
        </Link>
        <Link to="/insight/events" style={{ textDecoration: "none" }}>
          <TabItemContainer
            className={
              mode === "Mobile" ? "font-button1-en" : "font-button1-en"
            }
            isSelected={props.selectedTab === InsightMenu.EVENTS}
          >
            Events
          </TabItemContainer>
        </Link>
        <Link to="/insight/contents" style={{ textDecoration: "none" }}>
          <TabItemContainer
            className={
              mode === "Mobile" ? "font-button1-en" : "font-button1-en"
            }
            isSelected={props.selectedTab === InsightMenu.CONTENTS}
          >
            Contents
          </TabItemContainer>
        </Link>
        <Link to="/insight/news" style={{ textDecoration: "none" }}>
          <TabItemContainer
            className={
              mode === "Mobile" ? "font-button1-en" : "font-button1-en"
            }
            isSelected={props.selectedTab === InsightMenu.NEWS}
          >
            News
          </TabItemContainer>
        </Link>
        <Link to="/insight/blueletter" style={{ textDecoration: "none" }}>
          <TabItemContainer
            className={
              mode === "Mobile" ? "font-button1-en" : "font-button1-en"
            }
            isSelected={props.selectedTab === InsightMenu.BLUELETTER}
          >
            Blue Letter
          </TabItemContainer>
        </Link>
      </TabContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 64px;
  background-color: var(--bg-02);
`;

const TabContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  @media only screen and (max-width: 768px) {
    flex-wrap: nowrap;
    overflow: scroll;
    padding: 0;

    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

const TabItemContainer = styled.div<{ isSelected?: boolean }>`
  width: fit-content;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 32px;

  cursor: pointer;
  white-space: nowrap;
  color: ${(props) => (props.isSelected ? "var(--primary)" : "var(--grey-60)")};
  border-bottom: 2px solid
    ${(props) => (props.isSelected ? "var(--primary)" : "transparent")};

  @media only screen and (max-width: 768px) {
    padding: 0 16px;
    gap: auto;
  }
`;

export default React.memo(InsightTabs);
